import * as React from "react"
import CreativeCommunity from '../../components/Creative-Community/CreativeCommunity';
import Layout from "../../components/layout"
import Seo from "../../components/seo"
import { graphql } from "gatsby"

const IndexPage = ({data}) => {
  const pageData = {
    allContentfulElbrusPagesInTheWild: {
      nodes: data.allStoryblokEntry.edges
      .map(({ node }) => {
        const content = JSON.parse(node.content)
        return { ...content, id: node.id, contentful_id: content.contentfulId }
      })
    }
  }

  return (
    <Layout>
      <Seo title="Home" />
      <CreativeCommunity data={pageData} />
    </Layout>
  )
}

export default IndexPage;

export const query = graphql`
  {
    allStoryblokEntry(
      filter: {
        field_component: {eq: "productCategoryInTheWildEC2"}
        slug: {eq: "creative-community"}
      }
    ) {
      edges {
        node {
          id
          content
        }
      }
    }
  }
`
